import React, { Component } from "react";
import { connect } from "react-redux";
import UploadCategoryLanding from "./../UploadCategoryLanding";
import SelectDate from "./SelectDate";
import QuestionsList from "./QuestionsList";
import {
  questionsEmployeeLifecycle,
  questionsBusinessCulture,
  questionsProcessAndPolicies,
  questionsBoard,
} from "../../../utils/manualEntryQuestions";
import "./../UploadData.css";
import find from "lodash/find";
import { deepClone } from "./../../../utils/copyObject";
import { formatDate } from "./../../../utils/constants";
import * as url from "./../../../utils/url";
import axios from "./../../../axios";
import findIndex from "lodash/findIndex";
import { getFlatDataFromTree } from "react-sortable-tree";
import unionBy from "lodash/unionBy";
import filter from "lodash/filter";
import groupBy from "lodash/groupBy";
import remove from "lodash/remove";
import moment from "moment";
import upload_manual from "./../../../assets/upload_manual.svg";
import ReviewManualDataEntry from "../../../components/OrganizationSetup/Components/Review/ReviewManualDataEntry/ReviewManualDataEntry";
import SubmitSuccess from "./SubmitSuccess";
import EnterpriseBreadcrumb from "../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb";
import isEmpty from "lodash/isEmpty";
import { maturity_model_questions_cats_wise } from "../../DEIMaturityModel/data";

class ManualDataEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      questionsWithAnswer: [],
      kpiMasterList: [],
      error: { status: false, msg: "" },
      selectedDate: moment(),
      existingData: [],
      updatedQuestions: [],
      flatHierarchy: getFlatDataFromTree({
        treeData: this.props.user.organizationId.staticHierarchy.map((e) => ({
          label: e.title,
          value: e.officeKey,
          ...e,
        })),
        getNodeKey: ({ node }) => node.officeKey,
        ignoreCollapsed: false,
      }).map(({ node }) => {
        return { label: node.title, value: node.officeKey };
      }),
      hierarchyVersion:
        this.props.user.organizationId.hierarchyVersion !== undefined
          ? this.props.user.organizationId.hierarchyVersion
          : 1,
      selectedOffice: {},
    };
  }

  componentDidMount() {
    const unblock = this.props.history.block((location, action) => {
      if (
        action === "PUSH" &&
        !location.pathname.startsWith(`/home/upload-data/manual`)
      )
        return "You have not completed the process yet. Are you sure you want to leave without completing it?";
      if (action === "POP")
        return "You have not completed the process yet. Are you sure you want to leave without completing it?";
    });
    const unlisten = this.props.history.listen((location, action) => {
      if (location.pathname !== `/home/upload-data/manual`) {
        unlisten();
        unblock();
      }
    });
    axios.get(url.getKpiMaster).then(({ data }) => {
      const payload = data.data;
      console.log(payload);
      this.setState({
        kpiMasterList: payload,
      });
    });
  }

  //Load the saved answers
  loadQuestionsWithAnswer = () => {
    const date = formatDate(this.state.selectedDate);
    const officeKey = this.state.selectedOffice.value;
    let payload = {
      officeKey: encodeURIComponent(officeKey),
      date,
    };
    // {
    //   params: {
    //     product: this.product
    //   }
    console.log("fetch previous survey---");
    let json_payload = JSON.stringify(payload);
    // ${url.getExistingSurvey}${objectEncode(payload)}
    // axios.get(`${url.getChartAnalytics}${objectEncode(getFilterObject)}`).then(({ data }) => {
    axios.get(`${url.getExistingSurvey}${json_payload}`).then(({ data }) => {
      console.log("data---", data);
      let questionsWithAnswer = [];
      const existingData = data.data.length > 0 ? data.data[0].docs : [];
      const allQuestions = questionsEmployeeLifecycle
        .concat(questionsBusinessCulture)
        .concat(questionsProcessAndPolicies)
        .concat(questionsBoard);
      allQuestions.map((questionMetaData) => {
        const { questions } = questionMetaData;
        questions.forEach((questionData) => {
          const questionIndex = findIndex(existingData, {
            text: questionData.text,
          });
          if (questionIndex > -1) {
            const existing = existingData[questionIndex];
            if (!isEmpty(existing.value)) {
              const answer = {};
              answer.category = questionMetaData.category;
              answer.text = questionData.text;
              answer.value = existing.value;
              answer.kpi = questionMetaData.kpiId;
              questionsWithAnswer.push(answer);
            }
          }
        });
      });
      this.setState({
        questionsWithAnswer: questionsWithAnswer,
      });
    });
  };

  getKpiObjectIdByCode = (kpiCode) => {
    const { kpiMasterList } = this.state;
    return find(kpiMasterList, { code: kpiCode })._id;
  };

  nextStep = () => {
    this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }));
  };

  goBack = () => {
    this.setState((prevState) => ({ currentStep: prevState.currentStep - 1 }));
  };

  goToStep = (step) => {
    this.setState({ currentStep: step });
  };

  handleDateSelectionContinue = () => {
    console.log("next ---", this.state);
    let { selectedOffice } = this.state;

    if (selectedOffice && selectedOffice.value) {
      this.setState({
        error: { status: false, msg: "" },
      });
      this.loadQuestionsWithAnswer();
      this.nextStep();
    } else {
      this.setState({
        error: { status: true, msg: "Please select an office" },
      });
    }
  };

  handleDateChanged = (date) => {
    // console.log('date is changesd---', date);
    // console.log('formated date', formatDate(date));

    this.setState({
      selectedDate: date,
    });
  };

  calculatePrpScore = (questionsWithAnswer) => {
    // console.log(questionsProcessAndPolicies);
    let questionsWithoutAnswer = [];
    questionsProcessAndPolicies.forEach((kpi) => {
      const output = kpi.questions.map((q) => {
        return {
          text: q.text,
          value: "",
          kpi: kpi.kpiId,
          category: kpi.category,
        };
      });
      questionsWithoutAnswer = questionsWithoutAnswer.concat(output);
    });
    // console.log(questionsWithAnswer);
    const allQuestions = unionBy(
      questionsWithAnswer,
      questionsWithoutAnswer,
      "text"
    );
    // console.log(allQuestions);
    const grouped = groupBy(allQuestions, (o) => o.kpi);
    let scoreByKpi = [];
    for (let key in grouped) {
      let score = 0;
      if (key === "PRP-5") {
        const MAX_SCORE_PRP5 = 12;
        const kpiInputs = [];
        grouped[key].forEach((q) => {
          kpiInputs.push({ text: q.text, value: q.value });
          if (q.value === "1-4 weeks") {
            score += 1;
          }
          if (q.value === "5-8 weeks") {
            score += 2;
          }
          if (q.value === ">8 weeks") {
            score += 3;
          }
        });
        scoreByKpi.push({
          kpiName: key,
          score: (score / MAX_SCORE_PRP5) * 100,
          kpiInputs: kpiInputs,
        });
      } else {
        const groupedQuestions = grouped[key];
        const allQuestionsByType = filter(questionsProcessAndPolicies, {
          kpiId: key,
        }).pop().questions;
        const maximumPossibleScore = allQuestionsByType
          .map((o) => o.score)
          .reduce((a, b) => a + b);
        const hasPositiveAnswer = filter(groupedQuestions, { value: "yes" });
        const kpiInputs = [];
        hasPositiveAnswer.forEach((a) => {
          const questions = find(allQuestionsByType, { text: a.text });
          score += questions.score;
        });
        groupedQuestions.forEach((a) => {
          kpiInputs.push({ text: a.text, value: a.value });
        });
        scoreByKpi.push({
          kpiName: key,
          score: (score / maximumPossibleScore) * 100,
          kpiInputs: kpiInputs,
        });
      }
    }
    // console.log(scoreByKpi);
    return scoreByKpi;
  };

  isMMQuestion = (text) => {
    const questions_wid_cats = [...maturity_model_questions_cats_wise];
    for (const item of questions_wid_cats) {
      for (const que of item.questions) {
        if (que.text == text) {
          return true;
        }
      }
    }

    return false;
  };

  handleQuestionsAnswered = (value, questionText, kpi, category) => {
    const { questionsWithAnswer, updatedQuestions } = this.state;

    const questions = deepClone(questionsWithAnswer);
    const questionsUpdated = deepClone(updatedQuestions);
    const i = findIndex(questions, { text: questionText });
    if (i > -1) {
      questions.splice(i, 1, {
        text: questionText,
        value: value,
        kpi: kpi,
        category: category,
      });
      if (this.isMMQuestion(questionText)) {
        questionsUpdated.splice(i, 1, { text: questionText,value:value });
      }
    } else {
      questions.push({
        text: questionText,
        value: value,
        kpi: kpi,
        category: category,
      });
      if (this.isMMQuestion(questionText)) {
        questionsUpdated.push({
          text: questionText,
          value: value,
          kpi: kpi,
          category: category,
        });
      }
    }
    this.setState({
      questionsWithAnswer: questions,
      updatedQuestions:questionsUpdated
    });
  };

  handleClear = (kpi) => {
    const { questionsWithAnswer } = this.state;
    const questions = deepClone(questionsWithAnswer);
    const toBeClearedArray = filter(questions, { kpi: kpi });
    if (toBeClearedArray.length > 0) {
      remove(questions, { kpi: kpi });
      const cleared = toBeClearedArray.map((o) => {
        o.value = "";
        return o;
      });
      this.setState({
        questionsWithAnswer: questions.concat(cleared),
      });
    }
  };

  handleSave = () => {
    const {
      questionsWithAnswer,
      selectedDate,
      selectedOffice,
      hierarchyVersion,
      updatedQuestions
    } = this.state;
    const formattedDate =  formatDate(selectedDate);
    const { isSetupFlow } = this.props;
    const prpQuestions = filter(questionsWithAnswer, (o) =>
      o.kpi.contains("PRP")
    );
    const nonPrpQuestions = filter(
      questionsWithAnswer,
      (o) => !o.kpi.contains("PRP")
    );
    const prpPayload = this.calculatePrpScore(prpQuestions);
    let surveyList = nonPrpQuestions
      .filter((o) => o.value && o.value.length > 0)
      .map((e) => {
        const returnObject = {};
        // returnObject.kpiName = this.getKpiObjectIdByCode(e.kpi);
        returnObject.kpiName = e.kpi;
        returnObject.score = e.value;
        returnObject.kpiInputs = [
          {
            text: e.text,
            value: e.value,
          },
        ];
        return returnObject;
      });
    if (prpPayload && prpPayload.length > 0) {
      surveyList = surveyList.concat(prpPayload);
    }
    const isTopLevelObject = this.props.user.organizationId.staticHierarchy.find(x => !x.parentNode)
    const payload = {
      selectedDate: formattedDate,
      surveyList: surveyList,
      office: { key: selectedOffice.value, name: selectedOffice.label },
      hierarchyVersion,
      updatedQuestions:isTopLevelObject ? this.state.updatedQuestions :[]
    };
    // console.log(payload);
    axios.post(url.saveSurvey, payload).then(async({ data }) => {
      if(updatedQuestions && updatedQuestions.length){
        const surveyListNew = data.data.mmSurveysBySelectedDate.map(item =>{
          let score = 0;

          const maximumPossibleScore = item.kpiInputs
            .map((o) => o.score)
            .reduce((a, b) => a + b) ||1;
    
          for (const itm of item.kpiInputs) {
            if (itm.optionsType === 1) {
              if (itm.value == "yes") {
                score += itm.score;
              }
            } else if (itm.optionsType === 3) {
              if (itm.value) {
                if (itm.value === "1-4 weeks") {
                  score += 1;
                }
                if (itm.value === "5-8 weeks") {
                  score += 2;
                }
                if (itm.value === ">8 weeks") {
                  score += 3;
                }
                if(itm.value==="none"){
                  score += 0
                }
               
              }
            } else if (itm.optionsType === 2) {
              console.log("ival__",itm.value)
              if (itm.value) {
                score += parseInt(itm.value)/100;
              }
            }
          }
    
        
    
          const scoreVal =
            maximumPossibleScore && score
              ? Math.round((score / maximumPossibleScore) * 100)
              : 0;


            return {
              ...item,
              score:scoreVal
            }
        })

      const updateReports = await axios
      .post(url.triggerScoreCalculation, {
        savedData: surveyListNew,
        selectedDate:formattedDate,
        isEdit: true,
      })
      }
      if (isSetupFlow) {
        this.props.history.replace("/home");
      } else {
        this.props.history.replace({
          pathname: "/home/upload-data/success",
          state: {
            fromPage: "MANUAL_DATA_ENTRY",
          },
        });
      }
    });
  };

  onOfficeSelect = (office) => {
    if (office) {
      this.setState({ selectedOffice: { ...office } });
    } else {
      this.setState({ selectedOffice: null });
    }
  };

  render() {
    const {
      currentStep,
      questionsWithAnswer,
      selectedDate,
      selectedOffice,
      flatHierarchy,
    } = this.state;
    const { orgAdmin } = this.props.user;
    // console.log(flatHierarchy);
    return (
      <div className={"mt60 sideBarMenuItems"} style={{ padding: "10px" }}>
        {orgAdmin && (
          <EnterpriseBreadcrumb
            top={""}
            linkText="Upload Data"
            link="/home/upload-data"
            activeText="Manual Data Entry"
            {...this.props}
          />
        )}
        {currentStep === 1 ? (
          <UploadCategoryLanding
            nextStep={this.nextStep}
            selectedCategory="Manual Data Entry"
            categoryDescription="Find our more about Diversity and Inclusion in your office by responding to survey-style questions."
            categoryIllustration={upload_manual}
          />
        ) : currentStep === 2 ? (
          <SelectDate
            onContinue={this.handleDateSelectionContinue}
            onDateChanged={this.handleDateChanged}
            onOfficeSelect={this.onOfficeSelect}
            selectedDate={selectedDate}
            selectedOffice={selectedOffice}
            flatHierarchy={flatHierarchy}
            currentStep={currentStep}
            error={this.state.error}
          />
        ) : currentStep === 3 ? (
          <QuestionsList
            onQuestionAnswered={this.handleQuestionsAnswered}
            questionsWithAnswer={questionsWithAnswer}
            questions={questionsEmployeeLifecycle}
            nextBtnAction={this.nextStep}
            currentStep={currentStep}
            nextBtnTxt="Continue"
            nxtBtnIcon="flaticon-next"
            goBack={this.goBack}
            onClear={this.handleClear}
            goToStep={this.goToStep}
          />
        ) : currentStep === 4 ? (
          <QuestionsList
            onQuestionAnswered={this.handleQuestionsAnswered}
            questionsWithAnswer={questionsWithAnswer}
            onClear={this.handleClear}
            questions={questionsBusinessCulture}
            nextBtnAction={this.nextStep}
            goBack={this.goBack}
            currentStep={currentStep}
            goToStep={this.goToStep}
            nextBtnTxt="Continue"
            nxtBtnIcon="flaticon-next"
          />
        ) : currentStep === 5 ? (
          <QuestionsList
            onQuestionAnswered={this.handleQuestionsAnswered}
            questionsWithAnswer={questionsWithAnswer}
            onClear={this.handleClear}
            questions={questionsProcessAndPolicies}
            nextBtnAction={this.nextStep}
            goBack={this.goBack}
            currentStep={currentStep}
            goToStep={this.goToStep}
            nextBtnTxt="Continue"
            nxtBtnIcon="flaticon-next"
          />
        ) : currentStep === 6 ? (
          <QuestionsList
            onQuestionAnswered={this.handleQuestionsAnswered}
            questionsWithAnswer={questionsWithAnswer}
            onClear={this.handleClear}
            questions={questionsBoard}
            nextBtnAction={this.nextStep}
            goBack={this.goBack}
            currentStep={currentStep}
            goToStep={this.goToStep}
            nextBtnTxt="Continue"
            nxtBtnIcon="flaticon-next"
          />
        ) : currentStep === 7 ? (
          <ReviewManualDataEntry
            nextBtnAction={this.handleSave}
            nextBtnTxt="Submit"
            currentStep={currentStep}
            goBack={this.goBack}
            nxtBtnIcon="flaticon-tick"
            office={selectedOffice.label}
            selectedDate={selectedDate}
            questionsWithAnswer={questionsWithAnswer}
            goToStep={this.goToStep}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

export default connect(mapStateToProps)(ManualDataEntry);
